import React, { Fragment, memo, useState } from "react";
import Popup from "./Popup";

const CLUB_ACTIVE = process.env.GATSBY_CLUB_ACTIVE;

const Signup = () => {
  const [isOpen, setOpen] = useState(false);
  const isPartnersClub = CLUB_ACTIVE === "club_pt";

  async function openPopup() {
    setOpen(true);
    document.body.style.overflow = "hidden !important";
  }

  async function closePopup() {
    setOpen(false);
    document.body.style.overflow = "hidden !important";
  }

  return (
    <Fragment>
      {!isPartnersClub && (
        <>
          <a
            className="cursor-pointer text-white font-bold hover:underline hover:underline-offset-[6px]"
            role="button"
            onClick={openPopup}
          >
            Join the Club
          </a>
          <Popup isOpen={isOpen} closePopup={closePopup} />
        </>
      )}
      {isPartnersClub && (
        <>
          <a
            className="cursor-pointer text-white font-bold hover:underline hover:underline-offset-[6px]"
            role="button"
            href="/account/register"
          >
            Sign up
          </a>
          <Popup isOpen={isOpen} closePopup={closePopup} />
        </>
      )}
    </Fragment>
  );
};
export default memo(Signup);
